import i18n from "intl/i18n"
import { Guid } from "@/types"

export enum AssetStoredStatus {
    notApplicable = "notApplicable",
    released = "released",
    stored = "stored",
}

export interface IGetAssetDisplayStatusDto {
    id: Guid
    status: AssetStoredStatus
    locationName?: string | null
    reservationId?: Guid | null
}

export default class AssetDisplayStatus {
    status: AssetStoredStatus
    locationName?: string | null
    reservationId?: Guid

    constructor(dto: IGetAssetDisplayStatusDto) {
        this.status = dto.status
        this.locationName = this.status === AssetStoredStatus.stored && !dto.locationName
            ? i18n.t("common.noWarehouse")
            : dto.locationName
        this.reservationId = dto.reservationId ?? undefined
    }
}
